import { render, staticRenderFns } from "./ReservationCreate.vue?vue&type=template&id=229461ba&scoped=true&"
import script from "./ReservationCreate.vue?vue&type=script&lang=js&"
export * from "./ReservationCreate.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCreate.vue?vue&type=style&index=0&id=229461ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229461ba",
  null
  
)

export default component.exports